import React, { Component } from 'react';
import ReactTable from "react-table";
import { withRouter } from 'react-router-dom';
import couterpart from 'counterpart';

import DatePicker from 'react-datepicker';
import {ToastsContainer, ToastsStore} from 'react-toasts';
import Spinner from 'react-spinner-material';
import { FaFilter } from 'react-icons/fa';

import Dialog from 'react-bootstrap-dialog';

import {MdModeEdit} from 'react-icons/md';

import { WO_ADMIN_APPROVED, DATA_TYPE_DESIGN, WO_READY, WO_NOT_ADMIN_APPROVED, WO_NOT_READY } from '../constants';

import MenuComponent2 from './MenuComponent2';

import WorkOrderDataService from '../services/WorkOrderDataService';
import AuthenticationService from '../services/AuthenticationService';
import MasterDataService from '../services/MasterDataService';
// import UserDataService from '../services/UserDataService';

import WorkOrderUtil from '../utilities/WorkOrderUtil';

import "react-table/react-table.css";
import "../css/style.css";
import {  ICON_COLOR } from '../icon';

import Modal from 'react-bootstrap/Modal'


class ExportCKFileList extends Component {
  constructor () {
    super();
    let fromDate = new Date(new Date().getTime() - 1*30*24*60*60*1000*3);//1 month
    fromDate = WorkOrderUtil.convertToyyyyMMddhhmmString(fromDate);
    let toDate = new Date();
    toDate = WorkOrderUtil.convertToyyyyMMddhhmmString(toDate);

    let count1Desc = AuthenticationService.isDesigner() ? "Approved bởi admin"  : couterpart.translate('ckfiles_readyCk');
    // let count2Desc = AuthenticationService.isDesigner() ? "Đã export ck"  : couterpart.translate('ckfiles_doneCk')

    this.state = {
      spinnerVisible: false,
      fromDate: fromDate,
      toDate: toDate,
      allStatus: [],
      selected: null,
      ckExportFiles: [],
      workOrders: [],
      selectedPage: 0,
      selectedRow: 0,
      selectAll: 0,
      selected: [],
      page: 0,
      loading: false,
      pages: 0,
      pageSize: 10,
      show: false,
      woPage: 0,
      woLoading: false,
      woPages: 0,
      woPageSize: 20,
      columns : [
        {
          id: "idx",
          accessor: "",
          width: 40,
          Cell: row =>(
            <div style={{ padding: "10px"}}>{row.index + 1}</div>
          )
        },              
        {
          Header: couterpart.translate('ckfiles_excel'),
          accessor: 'filename',
          width: 250,
          Cell: row =>(
            this.linkToDetails(row)
          ) 
        },{
          Header: couterpart.translate('ckfiles_corel'),
          accessor: 'corel',
          filterable: false
        },{           
          Header: couterpart.translate('ckfiles_quantity'),
          accessor: 'quantity',
          filterable: false,
          Cell: row =>(
            this.linkToList(row, 'quantity')
          )
        // },{           
        //   Header: couterpart.translate('ckfiles_exportedCk'),
        //   accessor: 'exportCkCount',
        //   filterable: false,
        //   Cell: row =>(
        //     this.linkToList(row, 'exportCkCount')
        //   )
        // },{           
        //   Header: couterpart.translate('ckfiles_exportedCk'),
        //   accessor: 'assignedCount',
        //   filterable: false,
        //   Cell: row =>(
        //     this.linkToList(row, 'assignedCount')
        //   )                      
        },{           
          Header: count1Desc,
          accessor: 'readyCount',
          filterable: false,
          Cell: row =>(
            this.linkToList(row, 'readyCount')
          )          
        // },{           
        //   Header: count2Desc,
        //   accessor: 'ckDoneCount',
        //   filterable: false,
        //   Cell: row =>(
        //     this.linkToList(row, 'ckDoneCount')
        //   )                                                            
        },{
            Header: couterpart.translate('ckfiles_ngayck'),
            accessor: 'exportAtTs',
            width: 250
        },{
            Header: couterpart.translate('ckfiles_complete_ck'),
            accessor: 'completeAtTs',
            width: 250            
        },{           
            Header: '',
            accessor: '',
            width: AuthenticationService.isDesigner()? 90: 0,
            Cell: row =>(
              <div style={{ textAlign: "center" }}>
                  {this.renderEditButton(row)}
              </div>
            )
      }],
      columnName: '',
      selectedExportInfoId: 0,
    };
    MasterDataService.retrieveAllStatus().then(data => {
      this.setState(
        {
          woColumns : [
          {
            id: "idx",
            accessor: "",
            width: 40,
            Cell: row =>(
              <div style={{ padding: "10px"}}>{row.index + 1}</div>
            )
          },          
          {
            Header: couterpart.translate('work_order_urgent_level'),
            accessor: 'isUrgentByCustomer',
            width: 50,
            Cell: row => {
              row.styles['color'] = row.value === 1 ? 'red' : 'black';
              return row.value === 1 ? 'X' : '';
            },           
            filterable: false,
            filterMethod: (filter, row) =>
            row[filter.id].includes(filter.value)             
          },{
            Header: couterpart.translate('work_order_no'),
            accessor: 'workOrderNo',
            width: 150
          },{           
            Header: couterpart.translate('shop_pcode'),
            accessor: 'fullPCode',
            filterable: false,
            width: 150
          },{
            Header: couterpart.translate('work_order_quantity'),
            accessor: 'qty',
            width: 70
          },{
            Header: couterpart.translate('work_order_customer'),
            accessor: 'customer',
            filterable: false                                                       
          },{
            Header: 'MT',
            accessor: 'fimg',
            width: 200,
            Cell: row =>(
              this.fImageRender(row)
            )
          },{
            Header: 'MS',
            accessor: 'bimg',
            width: 200,
            Cell: row =>(
              this.bImageRender(row)
            )
          },{
            Header: couterpart.translate('ckfiles_corel_s'),
            accessor: 'corel',
            width: 200                       
          },{
            Header: couterpart.translate('item_assigned_to'),
            accessor: 'designer',
            filterable: false,
            sortable: true,
            width: 100
          },{
            Header: couterpart.translate('work_order_worker'),
            accessor: 'workerFullName',
            filterable: false,
            width: 100
          },{
            Header: couterpart.translate('work_order_ckExportFile'),
            accessor: 'ckExportFile',
            width: 200
          },{          
            Header: couterpart.translate('ship_to'),
            accessor: 'shipTo',
            width: 70                                            
          },{          
            Header: couterpart.translate('work_order_status'),
            accessor: 'status',
            width: 150,
            Cell: props => WorkOrderUtil.getStatusDescription(data, props.value)                                                                            
          },{           
            Header: couterpart.translate('work_order_action'),
            accessor: 'action',
            width: 90,
            Cell: row =>(
              <div style={{ textAlign: "center" }}>
                  {this.renderCkButton(row)}
              </div>
            )
        }]
      });
    });   
  }

  linkToDetails(row){
      return(
          <label className="label_link" href="#!" onClick={() => {this.downloadForCk(row)}}>{row.original.filename}</label>
      )
  } 

  linkToList(row, columnName){
    return(
        <label className="label_link" href="#!" onClick={() => {this.showWOList(row, columnName)}}>{row.original[columnName]}</label>
    )
  } 

  linkToCorel(row){
      return(
          <a href="D:/Temp/images" target="_blank">{row.original.filename}</a>
      )
  }

  downloadForCk (row){
    try{
      this.setState({spinnerVisible: true}, () =>{
        WorkOrderDataService.downloadForCk({exportInfoId: row.original.id, filename: row.original.filename, isDownload: 1}).then(data =>{
          const downloadUrl = window.URL.createObjectURL(new Blob([data]));
          const link = document.createElement('a');
          link.href = downloadUrl;
          link.setAttribute('download', row.original.filename);
          document.body.appendChild(link);
          link.click();
          link.remove();
          this.sleep(100).then(() => {this.setState({spinnerVisible: false});});    
        });
      });
    } catch(e) {
      this.sleep(100).then(() => {this.setState({spinnerVisible: false});});
    }     
  }

  showWOList(row, columnName){ 
    this.setState({
      selectedExportInfoId: row.original.id,
      columnName: columnName,
      show: true,
      woLoading: true      
    }, () => {
      this.loadWorkOrders();
    });
  }

  loadWorkOrders(){
    let status = this.state.columnName === 'quantity'? WO_NOT_READY : WO_READY;
    if (AuthenticationService.isDesigner()){
      status = this.state.columnName === 'quantity'? WO_NOT_ADMIN_APPROVED :  WO_ADMIN_APPROVED;
    }

    let woPage = this.state.selectedWoPage? this.state.selectedWoPage : 0;
    let woPageSize = this.state.woPageSize; 

    let info = {
      exportInfoId: this.state.selectedExportInfoId,
      woStatus: status,
      page: woPage === undefined? 0: woPage,
      pageSize: woPageSize === undefined? 20: woPageSize
    };

    WorkOrderDataService.findWOByExportInfoAndStatus(info).then(res => {
      if(res.message === undefined && res.data !== undefined &&  res.data instanceof Array){ 
        this.setState({ 
          show: true,
          workOrders: res.data,
          woLoading: false, woPages: res.pages, woPage: woPage, woPageSize: woPageSize
        });
      } else {
        this.setState({ workOrders:  [], woLoading: false, woPages: 0, woPage: 0, woPageSize: woPageSize});
      }
    });
  }


  isExportedCK(row){
    if (row.original.corel !== undefined && row.original.corel !== null && row.original.corel.trim().length > 10){
      return true;
    }
    return false;
  } 

  isCompletedCK(row){
    if (row.original.completeAt !== undefined && row.original.completeAt !== null && row.original.completeAt.trim().length > 10){
      return true;
    }
    return false;
  }   

  renderEditButton(row){
    if (AuthenticationService.isDesigner() && (!this.isExportedCK(row))){
      return (<div>
              <button className="myButton" onClick={() => this.exportCK(row)}>
              <MdModeEdit color={ICON_COLOR}/>
              &nbsp;{ couterpart.translate('button_export_ck') }</button>
                </div>
              );
    }else if (AuthenticationService.isKhac() && this.isExportedCK(row) && !this.isCompletedCK(row)){
      return (<></>);      
    } else {
      return (<></>);
    }
  }

  renderCkButton(row){
    if (AuthenticationService.isKhac() && row.original.status === WO_READY){    
      return (<div>
              <button className="myButton" onClick={() => this.completeCKByWorkOrder(row)}>
              <MdModeEdit color={ICON_COLOR}/>
              &nbsp;{ couterpart.translate('button_ck') }</button>
                </div>
              );
    } else {
      return (<></>);
    }
  }    

  exportCK(e){
    let ret = window.confirm(couterpart.translate('msg_export_ck_change_confirm'));
    let valid = true;
    if (ret === true){
      WorkOrderDataService.checkAlreadyCKByIds({ 
        exportInfoId: e.original.id,
        filename: e.original.filename
      }).then(data => {
        if (data !== null && data != undefined && data.trim().length > 0){
          alert("Work Orders đã được xuất cắt khắc. \n\r" + data);
        } else {
          WorkOrderDataService.changeToExportCatKhac({ 
            exportInfoId: e.original.id,
            filename: e.original.filename
          }).then(data => {
            console.log('EXPORTED CK')
            this.filterOrdersBy();
          });
        }
      });
    }
  }

  // completeCK (e){
  //   try{
  //     let ret = window.confirm(couterpart.translate('msg_export_ck_change_confirm'));
  //     if (ret === true){
  //       WorkOrderDataService.getUnassignedBy({ 
  //         exportInfoId: e.original.id
  //       }).then(data => {
  //         console.log('CHECK ASSIGN CK', data);
  //         if (data.length > 0){
  //           alert(couterpart.translate('msg_complete_ck_without_assign') + ': ' + data.join());
  //           console.log('UNASSIGNED LIST', data);
  //         } else {
  //           this.setState({spinnerVisible: true}, () =>{
  //             WorkOrderDataService.completeCatKhac({ 
  //               exportInfoId: e.original.id
  //             }).then(data => {
  //               console.log('COMPLETED CK', data)
  //               this.filterOrdersBy();
  //             });
  //             this.sleep(100).then(() => {this.setState({spinnerVisible: false});}); 
  //           });
  //         }        
  //       });
  //     }
  //   }catch(e){
  //     this.sleep(100).then(() => {this.setState({spinnerVisible: false});}); 
  //     console.log(e);
  //   }
  // }

  completeCKByWorkOrder (e){
    try{
      let ret = window.confirm(couterpart.translate('msg_export_ck_change_confirm'));
      if (ret === true){
        WorkOrderDataService.getUnassignedBy({ 
          exportInfoId: this.state.selectedExportInfoId
        }).then(data => {
          console.log('CHECK ASSIGN CK', data);
          if (data.length > 0){
            alert(couterpart.translate('msg_complete_ck_without_assign') + ': ' + data.join());
            console.log('UNASSIGNED LIST', data);
          } else {
            this.setState({spinnerVisible: true}, () =>{
              WorkOrderDataService.completeCatKhacByWorkOrder({ 
                exportInfoId: this.state.selectedExportInfoId,
                workOrderId:  e.original.id
              }).then(data => {
                this.loadWorkOrders();
                this.filterOrdersBy();
              });
              this.sleep(100).then(() => {this.setState({spinnerVisible: false});}); 
            });
          }        
        });
      }
    }catch(e){
      this.sleep(100).then(() => {this.setState({spinnerVisible: false});}); 
      console.log(e);
    }
  }     

  componentDidMount () {
    // var userId = AuthenticationService.getUserId();

    MasterDataService.retrieveAllStatus().then(data => {
      this.setState({ allStatus:  data}) 
    });

    let fromDate = WorkOrderUtil.getItem("ckfiles.fromDate");
    let toDate = WorkOrderUtil.getItem("ckfiles.toDate");
    const numOfMonths = 1;
    if (fromDate === null || fromDate === undefined) {
      fromDate = new Date(new Date().getTime() - numOfMonths*30*24*60*60*1000);//1 month
      fromDate = WorkOrderUtil.convertToyyyyMMddhhmmString(fromDate);
    }

    if (toDate === null || toDate === undefined) {
      toDate = new Date(new Date().getTime() + 60*60*1000*3);//1 hour
      toDate = WorkOrderUtil.convertToyyyyMMddhhmmString(toDate);
    }

    let tmp = WorkOrderUtil.getItem('ckfiles.selectedPage');
    let iSelectPage = 0;
    if (tmp !== undefined) {
      iSelectPage = parseInt(tmp);
    }

    let selectedRow = WorkOrderUtil.getItem('ckfiles.selectedRow') ? parseInt(WorkOrderUtil.getItem('ckfiles.selectedRow')) : 0;
    let selectedWorkOrderId = WorkOrderUtil.getItem('ckfiles.selectedWorkOrderId') ? parseInt(WorkOrderUtil.getItem('ckfiles.selectedWorkOrderId')) : 0;
        
    this.setState({ 
      fromDate:  fromDate, 
      toDate: toDate, 
      woStatus: WorkOrderUtil.getItem("ckfiles.woStatus"),
      selectedRow: selectedRow, 
      selectedWorkOrderId: selectedWorkOrderId, 
      selectedPage: iSelectPage
    }, () => {
      this.filterOrdersBy();
    });
  }

  filterOrdersBy(){
    if ((this.state.selectedPage < 0) || (this.state.pageSize < 0)){
      return;
    }
    this.setState({ loading: true });

    var fromDate = this.state.fromDate;
    var toDate = this.state.toDate;
    var woStatus = this.state.woStatus;

    let page = this.state.selectedPage;
    let pageSize = this.state.pageSize;     

    WorkOrderDataService.fetchCkFiles({ 
        fromDate: fromDate, 
        toDate: toDate, 
        woStatus: woStatus, 
        dataType: DATA_TYPE_DESIGN,
        page: page === undefined? 0: page,
        pageSize: pageSize === undefined? 10: pageSize         
      } )
      .then(res => {
      if(res.message === undefined && res.data !== undefined &&  res.data instanceof Array){     
        this.setState({ ckExportFiles:  res.data, loading: false, pages: res.pages, page: page, pageSize: pageSize},
        () => {
          this.saveSearchInfo(fromDate, toDate, woStatus);
        });
      }else{
        this.setState({ ckExportFiles:  [], loading: false, pages: 0, page: 0, pageSize: pageSize});
        ToastsStore.error(res.message);
      }   
    });
  }  

  clearSearchInfo() {
    WorkOrderUtil.removeItem("ckfiles.fromDate")
    WorkOrderUtil.removeItem("ckfiles.toDate")
    WorkOrderUtil.removeItem("ckfiles.woStatus")
  }
  saveSearchInfo(fromDate, toDate, woStatus){
    WorkOrderUtil.saveItem("ckfiles.fromDate", fromDate);
    WorkOrderUtil.saveItem("ckfiles.toDate", toDate);  
    WorkOrderUtil.saveItem("ckfiles.woStatus", woStatus);
  }

  onFilter() {
    this.clearSearchInfo();
    this.filterOrdersBy();
  }

  handleFromDateChange(date){
    var sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
    this.setState(prevState => ({                 
      fromDate: sDate                   
    }));
  }

  handleToDateChange(date){
    var sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
    this.setState(prevState => ({                 
      toDate: sDate                   
    }));
  }

  renderExportFileList () {
    if (this.state.ckExportFiles === undefined || this.state.ckExportFiles === null || !(this.state.ckExportFiles instanceof Array)){
        return (<></>);
    }

    if (this.state.ckExportFiles.message !== undefined) {
      return (<div className="error-msg"> { this.state.ckExportFiles.message }</div>);
    } 
    // console.log('this.state.selectedPage, data', this.state.selectedPage, this.state.ckExportFiles)
    return (
      <ReactTable
        NoDataComponent={() => null} 
        // PaginationComponent={ReactTablePagination}
        previousText={"<"}
        nextText={">"}
        data={this.state.ckExportFiles}
        columns={this.state.columns}
        page={this.state.selectedPage}
        onPageChange={pageIndex => {
          this.setState({ selectedPage: pageIndex }, () => {
          this.filterOrdersBy()
          })
        }}
        onPageSizeChange={(pageSize, pageIndex) => {
          this.setState({ page: pageIndex, pageSize: pageSize }, () => {
            this.filterOrdersBy()
          });
        }}          
        loading= { this.state.loading }  
        pages={ this.state.pages }
        headerStyle= {{
          'background-color' : 'green'
        }}
        getTrProps={(state, rowInfo, column) => { 
            if (rowInfo && rowInfo.row) {
              // console.log('this.state.selectedRow - rowInfo.index',this.state.selectedRow, rowInfo.index)
              return {
                onClick: (e) => {
                  this.setState({
                    selectedRow: rowInfo.index,
                    workOrderId: rowInfo.original.id
                  }, () => {
                    WorkOrderUtil.saveItem('ckfiles.selectedRow', this.state.selectedRow)
                    WorkOrderUtil.saveItem('ckfiles.selectedWorkOrderId', this.state.workOrderId)
                  })
                },
                style: {
                  background: rowInfo.index === this.state.selectedRow ? '#DCDCDC' : 'white',
                  color: rowInfo.index === this.state.selectedRow ? 'white' : 'black',
                  padding:1
                }
              }
            }else{
              return {}
            }
          }
        }
        defaultPageSize = {10}
        showPageSizeOptions = {true}
        pageSizeOptions = {[3, 5, 10, 20]}
      />      
    );    
  } 

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  renderWoList(){
    return(
      <div className="row">
        <div className="col-12">
          <ReactTable
            manual
            NoDataComponent={() => null} 
            previousText={"<"}
            nextText={">"}
            onPageChange={pageIndex => {
              this.setState({ selectedWoPage: pageIndex, woLoading: true }, () => {
                this.loadWorkOrders()
              })
            }}
            onPageSizeChange={(pageSize, pageIndex) => {
              this.setState({ woPage: pageIndex, woPageSize: pageSize, woLoading: true }, () => {
                this.loadWorkOrders()
              });
            }}                             
            data={this.state.workOrders}
            loading= { this.state.woLoading }  
            pages={ this.state.woPages }
            columns={this.state.woColumns}
            defaultPageSize = {20}
            showPageSizeOptions = {true}
            pageSizeOptions = {[1, 3, 5, 10, 20]}
          />
        </div>
      </div>
    );
  } 

  fImageRender(row){
    if (row.original.fimg === undefined || row.original.fimg === null){
      return (<></>)
    }
    return(
        <img className="imageBox linkTo" alt="" width={ 100 } height={70} src={`data:image/jpeg;base64,${row.original.fimg}`} name={'F' + row.original.workOrderNo} />
    )
  }

  bImageRender(row){
    if (row.original.bimg === undefined || row.original.bimg === null){
      return (<></>)
    }    
    return(
        <img className="imageBox linkTo" alt="" width={ 100 } height={70} src={`data:image/jpeg;base64,${row.original.bimg}`} name={ 'B' + row.original.workOrderNo} />
    )
  }     

  renderWorkOrderDialog(){
    return (
      <>
        <Modal
          show={this.state.show}
          onHide={() => this.setState({show: false})}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title">
              { couterpart.translate('wo_details_title') } 
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            { this.renderWoList() }
          </Modal.Body>
        </Modal>
      </>
    )
  }         

  render() {
    if (AuthenticationService.isWorker()) {
      return (
        <div>
          <MenuComponent2 isChild={this.props.isChild}/>
          { this.renderExportFileList() }
        </div>
      );
    }else{
      return (
            <div>
                <MenuComponent2 isChild={this.props.isChild}/>
                <ToastsContainer store={ToastsStore} position="bottom_center" />
                <br/>
                <div className="row border-top border-left border-right border-bottom border-light-gray" style={{ margin: '2px'}}>
                  <div className="col-12">
                    <div className="row">
                      <div className="col-4" style={{ padding: '5px'}}>
                        <div className="row">
                          <div className="col-2"><label><b>{couterpart.translate('order_date_from')}</b></label>:</div>
                          <div className="col-2">
                            <div className="customDatePickerWidth">
                              <DatePicker name="orderDateFrom" 
                                dateFormat="MM/dd/yyyy hh:mm"              
                                selected={ WorkOrderUtil.convertToDate(this.state.fromDate)}
                                onChange={this.handleFromDateChange.bind(this)}/>
                            </div>
                          </div>
                          <div className="col-2">
                            <label><b>{couterpart.translate('order_date_to')}</b></label>:</div>
                          <div className="col-2">
                            <div className="customDatePickerWidth">
                              <DatePicker name="orderDateTo" 
                                dateFormat="MM/dd/yyyy hh:mm"
                                selected={ WorkOrderUtil.convertToDate(this.state.toDate)}
                                onChange={this.handleToDateChange.bind(this)}/>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-8 " style={{ padding: '5px'}}>
                        <div className="row">
                          <div className="col-3">
                            <button className="myButton" 
                              onClick={this.onFilter.bind(this)}>
                              <FaFilter color={ICON_COLOR}/>
                              &nbsp;{couterpart.translate('button_filter')}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div> 
                  </div>            
                </div>                             
                { this.renderExportFileList() }
                <Spinner size={25} spinnerColor={ICON_COLOR} spinnerWidth={2} visible={this.state.spinnerVisible} />
                <Dialog ref={(component) => { this.dialog = component }} /> 
                { this.renderWorkOrderDialog() }               
            </div>      
      )
    }
  }
}

export default withRouter(ExportCKFileList);